<form [formGroup]="translationSettingsForm" (ngSubmit)="onSubmitTranslationSettings()">
  <div class="pt-2">
    <input
      type="checkbox"
      id="translationEnabled"
      formControlName="translationEnabled"
      (change)="onTranslationEnabledChanged($event)" />
    <label class="ps-1" for="translationEnabled">
      <h4>{{ 'Settings::Translation.Enabled' | abpLocalization }}</h4>
    </label>
    <div *ngIf="translationSettingsForm.get('translationEnabled').value">
      <div class="form-group pt-2 selector-class">
        <label for="originalLanguages">
          {{ 'Settings::Translation.OriginalLanguages' | abpLocalization }}
        </label>
        <ng-select
          formControlName="originalLanguages"
          id="originalLanguages"
          [items]="originalLanguagesDataSource"
          bindLabel="name"
          bindValue="code"
          [multiple]="true"
          [closeOnSelect]="false">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <input
              id="item-{{ index }}"
              type="checkbox"
              [ngModel]="item$.selected"
              [ngModelOptions]="{ standalone: true }" />
            {{ 'Settings::Call.Language.' + item.name | abpLocalization }}
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <span
              class="ng-value-icon left"
              aria-hidden="true"
              (click)="removeFromSelectedOriginalLanguages(item.code)">
              ×
            </span>
            <span class="ng-value-label">
              {{ 'Settings::Call.Language.' + item.name | abpLocalization }}
            </span>
          </ng-template>
        </ng-select>
        @if (!whiteLabelingEnabled) {
          <small
            class="form-text text-muted"
            [innerHtml]="
              'Settings::Conversation:Language:CompleteListInfo' | abpLocalization
            "></small>
        }
      </div>
      <div class="form-group pt-2">
        <div class="form-group">
          <label for="translatedLanguageCode">
            {{ 'Settings::Translation.TranslatedLanguages' | abpLocalization }}
          </label>
          <ca-select
            [class]="'below-all'"
            formControlName="translatedLanguageCode"
            [(ngModel)]="translatedLanguageCode">
            <ca-option *ngFor="let language of translatedLanguages" [value]="language.code">
              {{ 'Settings::Call.Language.' + language.name | abpLocalization }}
            </ca-option>
          </ca-select>
          @if (!whiteLabelingEnabled) {
            <small
              class="form-text text-muted"
              [innerHtml]="
                'Settings::Conversation:Language:CompleteListInfo' | abpLocalization
              "></small>
          }
        </div>
      </div>
      <div class="form-group pt-2">
        <div class="form-group">
          <label for="llmConfigurationId">
            {{ 'Settings::LLMConfiguration:LLMConfiguration' | abpLocalization }}
          </label>
          <ca-select [class]="'below-all'" [clearable]="true" formControlName="llmConfigurationId">
            <ca-option
              *ngFor="let llmConfiguration of llmConfigurations"
              [value]="llmConfiguration.id">
              {{ llmConfiguration.name }}
            </ca-option>
          </ca-select>
        </div>
      </div>
    </div>
    <div>
      <button type="button" type="submit" class="btn btn-primary mt-3">
        <i class="me-1 fas fa-save"></i>
        {{ 'AbpUi::Save' | abpLocalization }}
      </button>
    </div>
  </div>
</form>
